/**
 * Decrypted attachment bytes kept in memory next to their object URLs, so they can be forwarded
 * or re-used without fetching a blob: URL (the production CSP's connect-src doesn't allow blob:).
 * Memory only — never persisted; cleared on lock with the URLs.
 */
const blobs = new Map<string, Blob>();

export function rememberMediaBlob(eventId: string, blob: Blob): void {
  blobs.set(eventId, blob);
}

export function mediaBlobFor(eventId: string): Blob | undefined {
  return blobs.get(eventId);
}

export function forgetMediaBlobs(): void {
  blobs.clear();
}
